/* tslint:disable */
/* eslint-disable */
/**
 * Limber Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VideoAnalyticsData
 */
export interface VideoAnalyticsData {
    /**
     * Number of times the video has been opened.
     * @type {number}
     * @memberof VideoAnalyticsData
     */
    opens: number;
    /**
     * Number of times the video has been opened for at least 1 min.
     * @type {number}
     * @memberof VideoAnalyticsData
     */
    opens1min: number;
    /**
     * Number of times video completed (>=75% watched).
     * @type {number}
     * @memberof VideoAnalyticsData
     */
    completions: number;
    /**
     * Average percentage of the video watched.
     * @type {number}
     * @memberof VideoAnalyticsData
     */
    meanPercent: number;
    /**
     * Average percentage of the video watched, excluding times opened for less than 1 min.
     * @type {number}
     * @memberof VideoAnalyticsData
     */
    meanPercent1min: number;
}

export function VideoAnalyticsDataFromJSON(json: any): VideoAnalyticsData {
    return VideoAnalyticsDataFromJSONTyped(json, false);
}

export function VideoAnalyticsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): VideoAnalyticsData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'opens': json['opens'],
        'opens1min': json['opens-1min'],
        'completions': json['completions'],
        'meanPercent': json['mean-percent'],
        'meanPercent1min': json['mean-percent-1min'],
    };
}

export function VideoAnalyticsDataToJSON(value?: VideoAnalyticsData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'opens': value.opens,
        'opens-1min': value.opens1min,
        'completions': value.completions,
        'mean-percent': value.meanPercent,
        'mean-percent-1min': value.meanPercent1min,
    };
}


